import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import memoize from 'memoize-one';
import { Button, Form, Grid, Header, Message, Image, Input, Icon, Dropdown } from 'semantic-ui-react';
import i18next from 'i18next';

import { encryptStringData, decryptStringData } from '../../helpers/encryption';
import api from '../../actions/api';
import logoIcon from '../../assets/images/logo.png';

import './Password.scss';

class UserPassword extends Component {
    state = {
        userId: undefined,
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
        error: undefined,
        success: false
    };

    constructor(props) {
        super(props);

        this.renderFormFields = this.renderFormFields.bind(this);
    }

    componentDidMount() {
        if(this.props.userId) {
            this.setState({ userId: decryptStringData(this.props.userId) });
        }
    }

    validatePassowrdForm = () => {
        const { userId, currentPassword, newPassword, confirmPassword } = this.state;

        if ((!currentPassword && !userId) || !newPassword || !confirmPassword) {
            return 'missingField';
        }

        const decryptedNewPassword = decryptStringData(newPassword);
        const decryptedConfirmedPassword = decryptStringData(newPassword);
        if (decryptedNewPassword !== decryptedConfirmedPassword) return 'newPasswordsMismatch';

        return this.validatePassword(decryptedNewPassword);
    }

    validatePassword = (password) => {
        if (password.length < 6 || password.length > 25) {
            return 'passwordLength';
        }

        if (password.indexOf(' ') >= 0) {
            return 'includesSpaces';
        }

        if (!/^[a-zA-Z0-9!@#$%^&*]{6,25}$/.test(password)) {
            return 'invalidCharacters';
        }
    }

    handleSubmit = (event) => {
        event.preventDefault();

        const { userId, currentPassword, newPassword } = this.state;
        const { user } = this.props;

        const validationError = this.validatePassowrdForm();

        if (validationError) {
            this.setState({ error: validationError });
            return;
        }

        let passwordAction;
        if (userId) {
            passwordAction = api.auth.password.reset({ newPassword, reset: this.props.userId, userId });
        } else {
            passwordAction = api.auth.password.update({ newPassword, currentPassword, userId: user.id });
        }

        passwordAction.then(({ data }) => {
            this.setState({ error: undefined, success: true });
        }).catch(error => {
            this.setState({ error: error.response.data, success: false });
        });

    }

    renderFormFields(isDone) {
        if (isDone) return null;

        const formFields = [];

        if (!this.state.userId) {
            formFields.push(
                <Form.Field required key='currentPassword' name='currentPassword' className='pi-user-password-current'>
                    <label className='pi-user-password-current-label'>
                        {i18next.t('userSettings.currentPassword')}
                    </label>
                    <Input type='password' required placeholder={i18next.t('userSettings.currentPassword')}
                        onChange={(event, data) => { this.setState({ currentPassword: encryptStringData(data.value) }); }} />
                </Form.Field>
            );
        }

        formFields.push(
            <Form.Field required key='newPassword' name='newPassword' className='pi-user-password-new'>
                <label className='pi-user-password-new-label'>
                    {i18next.t('userSettings.newPassword')}
                </label>
                <Input type='password' required placeholder={i18next.t('userSettings.newPassword')}
                    onChange={(event, data) => { this.setState({ newPassword: encryptStringData(data.value) }); }} />
            </Form.Field>,
        );

        formFields.push(
            <Form.Field required key='confirmPassword' name='confirmPassword' className='pi-user-password-confirm'
                error={!!this.state.confirmPassword &&
                    decryptStringData(this.state.newPassword) !== decryptStringData(this.state.confirmPassword)
                } >
                <label className='pi-user-password-confirm-label'>
                    {i18next.t('userSettings.confirmPassword')}
                </label>
                <Input type='password' required placeholder={i18next.t('userSettings.confirmPassword')}
                    onChange={(event, data) => { this.setState({ confirmPassword: encryptStringData(data.value) }); }} />
            </Form.Field>
        );

        return formFields;
    }

    render() {
        const { user, userId } = this.props;

        if (!userId && !user) return null;

        return (
            <Grid centered verticalAlign='middle' className='pi-user-password-grid' >
                <Grid.Row verticalAlign='middle'>
                    <Grid.Column textAlign='center' verticalAlign='middle' style={{ maxWidth: 450 }}>
                        <div className='pi-user-password-header'>
                            <Image src={logoIcon} centered size="tiny" />
                            <Header as='h2'>
                                {i18next.t('userSettings.changePassword')}
                            </Header>
                        </div>
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row verticalAlign='middle'>
                    <Grid.Column style={{ maxWidth: 450 }}>

                        <Form onSubmit={this.handleSubmit} error={!!this.state.error} success={this.state.success}>
                            {this.renderFormFields(this.state.success)}
                            <Message error
                                header={i18next.t(`userSettings.passwordErrors.failedTitle`)}
                                content={i18next.t(`userSettings.passwordErrors.${this.state.error}`)}
                            />
                            <Message success>
                                <Message.Header>{i18next.t('userSettings.passwordSuccessTitle')}</Message.Header>
                                <Message.Content>
                                    <Button basic color='olive'
                                        content={i18next.t('userSettings.backToEntry')}
                                        as={Link}
                                        to={`/`}
                                        className='pi-user-password-back-to-login'
                                    />
                                </Message.Content>
                            </Message>
                            {
                                this.state.success ? null :
                                    <Button type='submit'>{i18next.t('save')}</Button>
                            }
                        </Form>

                    </Grid.Column>
                </Grid.Row>

            </Grid >
        );
    }
}

UserPassword.propTypes = {
    token: PropTypes.string,
    user: PropTypes.object,
    userId: PropTypes.string,
    
};

const mapStateToProps = (state) => {
    const { user, permissions } = state.auth;

    return { user, permissions };
};

export default connect(mapStateToProps, {})(UserPassword);
